import { TFunction } from 'next-i18next/pages'
import { isInPast } from 'shared/utils/date-time/is-in-past'

/**
 * Validates that a given date string is not in the past.
 *
 * This function checks if the provided date string represents a date that is in the past.
 * If the date is in the past, it returns a localized error message. Otherwise, it returns `true`.
 *
 * @param {TFunction} t - A translation function used to retrieve localized error messages.
 * @param {string | null} value - The date string to validate. If `null`, the function returns `true`.
 * @returns {string | true} - Returns `true` if the date is not in the past or if the value is `null`.
 *                          - Returns a **localized** error message if the date is in the past.
 */
export const validateNotPastDate = (t: TFunction, value: string | null): string | true => {
  if (!value) return true
  const date = new Date(value)

  const error = t('validation.past_date_error')
  return !isInPast(date) || error
}
